import styled from "@emotion/styled";
import { SignUpButton } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/sign-up-button";

import { fontRoboto } from "shared/lib/styles";

import IconArrowPrevious from "./icon-arrow-prev.svg";

export const StyledIconArrowPrevious = styled(IconArrowPrevious)`
  path {
    stroke: #4585ff;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: stretch;
  align-items: center;

  margin-inline-end: 12px;

  cursor: pointer;
`;

type EmailInputProps = {
  $isError: boolean;
};
export const EmailInput = styled.input<EmailInputProps>`
  inline-size: 100%;
  block-size: 35px;
  padding-inline-start: 10px;

  color: #000000;
  font-size: 16px;
  font-family: ${fontRoboto};

  border: 1px solid #d7d7d7;
  border-color: ${props => (props.$isError ? "#eb4254" : "#d7d7d7")};
  border-radius: 2px;
  &::placeholder {
    color: #999999;
  }
`;

export const WarningMessage = styled.div`
  margin-block: 2px 0;
  margin-inline: 2px 0;

  color: #eb4254;
  font-size: 10px;
  font-family: ${fontRoboto};
  line-height: 11px;
`;
export const InputContainer = styled.div`
  margin-inline-end: 8px;
`;

export const Form = styled.form`
  display: flex;
`;

export const Container = styled.div`
  display: flex;
`;

export const StyledSignupButton = styled(SignUpButton)``;
